import { useTranslation } from "react-i18next";
import { Button, EmptyState } from "@boligportal/bricks-ui";
import { Link } from "@tanstack/react-router";

export const FallbackEmpty = () => {
  const { t } = useTranslation();

  return (
    <EmptyState.Root size="md">
      {/*
      <EmptyState.Illustration>
        TODO: Add a nice 404 illustration here with the illustration prop
      </EmptyState.Illustration>
      */}
      <EmptyState.Content>
        <EmptyState.Title>{t("errors.not_found_headline")}</EmptyState.Title>
        <EmptyState.Description>
          {t("errors.not_found_description")}
        </EmptyState.Description>
      </EmptyState.Content>
      <EmptyState.Actions>
        <Button
          asChild
          size="sm"
          color="primary-administration"
        >
          <Link
            to="/"
            replace
          >
            {t("errors.not_found_action")}
          </Link>
        </Button>
      </EmptyState.Actions>
    </EmptyState.Root>
  );
};
